/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="12" height="8" viewBox="0 0 12 8" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>

        <polygon points="11.931 .726 11.222 .021 5.999 5.269 .705 0 0 .709 6.003 6.683" className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'ChevronDownIcon';

export default Icon;
